import React, {ReactNode} from "react";
import {FailedSvg, PixelConnectedSvg, PixelNotConnectedSvg, ProcessSvg} from "@/assets/svg/StatusLogoSvg";
import {TPixelStatus} from "@/types/pixelStatus/pixelStatusTypes";
import {TSideBarNavigation} from "@/types/navigation/navigationTypes";

export const buttons: TSideBarNavigation[] = [
    "filter",
    "custom",
    // "pixel",
    "files",
];

export const PixelStatusSvg: Record<TPixelStatus, (color?: string) => ReactNode> = {
    process: (color) => <ProcessSvg color={color}/>,
    connected: (color) => <PixelConnectedSvg color={color}/>,
    notConnected: (color) => <PixelNotConnectedSvg color={color}/>,
    failed: (color) => <FailedSvg color={color}/>,
}